const TopicIntro = ({
    sectionName,
    sectionDescription,
    topicRange,
    showRatingScale = true,
    isRequired = true,
    ...props
}) => {
    const ratingScale = [
        {value: 1, label: "Orientee completely dependent on preceptor's guidance"},
        {value: 2, label: "Orientee frequently requires preceptor feedback/assistance"},
        {
            value: 3,
            label: "Orientee successfully completes task without preceptor assistance but continued supervision.",
        },
        {
            value: 4,
            label: "Orientee successfully completes task without direct supervision, but seeks out preceptor when assistance is needed.",
        },
        {value: 5, label: "Orientee fully independent without preceptor input or direct supervision."},
    ]

    return (
        <div>
            <div className="d-flex flex-row">
                <span className="badge badge-lg badge-primary mb-2">{topicRange}</span>
            </div>
            <div className="d-flex flex-row">
                <h1 className="d-flex flex-column text-dark fw-bold fs-2x">{sectionName}</h1>
            </div>
            <div className={`d-flex flex-column text-dark ${showRatingScale ? "fs-5 mb-5" : "fs-4 mb-4"}`}>
                {sectionDescription}
            </div>
            {showRatingScale && (
                <>
                    <h2 className="d-flex flex-column text-dark fw-bold">Assessment Rating Scale</h2>
                    {ratingScale.map((item) => (
                        <div key={item.value} className="d-flex align-items-center mb-4">
                            <div className="symbol symbol-30px me-2">
                                <div className="symbol-label fs-5 fw-bold bg-primary text-white">{item.value}</div>
                            </div>
                            <span className="text-dark fs-5 me-1">{item.label}</span>
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

export default TopicIntro
